import React, { ReactElement } from "react";

interface GlobalKeyboardActionProps {
  onEnterPress?: () => void;
  onEscPress?: () => void;
  onSpacePress?: () => void;
  manually?: boolean;
}

const EventName = "keydown";

const isDebug = false;

export class GlobalKeyboardAction extends React.PureComponent<GlobalKeyboardActionProps> {
  constructor(props: GlobalKeyboardActionProps) {
    super(props);
    this.handler = this.handler.bind(this);
  }

  private handler(e: KeyboardEvent) {
    if (process.env.NODE_ENV === "development" && isDebug) {
      console.error(`GlobalKeyboardAction: ${e.code}`);
    }
    if (e.isComposing) {
      return;
    }
    switch (e.code) {
      case "Escape":
        this.props.onEscPress && this.props.onEscPress();
        break;
      case "Space":
        this.props.onSpacePress && this.props.onSpacePress();
        break;
      case "Enter":
        this.props.onEnterPress && this.props.onEnterPress();
        break;
    }
  }

  componentDidMount(): void {
    if (!this.props.manually) {
      this.install();
    }
  }

  componentWillUnmount(): void {
    this.uninstall();
  }

  install(): void {
    if (process.env.NODE_ENV === "development" && isDebug) {
      console.error("GlobalKeyboardAction: install");
    }
    document.addEventListener(EventName, this.handler);
  }

  uninstall(): void {
    if (process.env.NODE_ENV === "development" && isDebug) {
      console.error("GlobalKeyboardAction: uninstall");
    }
    document.removeEventListener(EventName, this.handler);
  }

  render(): ReactElement {
    return <div style={{ display: "none" }}></div>;
  }
}
